import {
  setISOWeek,
  startOfISOWeek,
  endOfISOWeek,
  subDays,
  format,
  addBusinessDays,
} from 'date-fns';

function getFirstAndLastDayOfWeek(weekNumber, year) {
  year = year || new Date().getFullYear();
  const start = new Date(year, 0, 1);
  const week = setISOWeek(start, weekNumber);
  return {
    first: startOfISOWeek(week),
    last: subDays(endOfISOWeek(week), 2),
  };
}

function getNumberOfWeek(numOfWeeks) {
  let now = new Date();
  now.setDate(now.getDate() + numOfWeeks * 7);
  const firstDayOfYear = new Date(now.getFullYear(), 0, 1);
  const pastDaysOfYear = (now - firstDayOfYear) / 86400000;
  return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
}

function getEstimatedDeliverySpan(extraWeeks, dateFormat = 'MM/dd') {
  const { first, last } = getFirstAndLastDayOfWeek(getNumberOfWeek(extraWeeks));
  const firstFormatted = format(first, dateFormat);
  const lastFormatted = format(last, dateFormat);
  return `${firstFormatted} - ${lastFormatted}`;
}

const getMtoDeliveryDate = (deliveryTime, string, weekString, region) => {
  // Normalize and coerce inputs
  const regionCode = (region || '').toString().toUpperCase();
  const weeksOffset = Number(deliveryTime) / 7;

  // DK uses explicit week number phrasing
  if (regionCode === 'DK') {
    const numberOfWeek = getNumberOfWeek(weeksOffset);
    return `${string}: ${weekString} ${numberOfWeek}`;
  }

  // Select date format: US => MM/dd, everywhere else => dd/MM
  const dateFormat = regionCode === 'US' ? 'MM/dd' : 'dd/MM';
  const estimatedDeliverySpan = getEstimatedDeliverySpan(weeksOffset, dateFormat);

  return `${string}: ${estimatedDeliverySpan}`;
};

const getDeliveryDateRange = (minDays, maxDays, dateFormat = 'dd/MM') => {
  const today = new Date();
  const minDate = addBusinessDays(today, minDays);
  const maxDate = addBusinessDays(today, maxDays);
  return `${format(minDate, dateFormat)}-${format(maxDate, dateFormat)}`;
};

export { getMtoDeliveryDate, getDeliveryDateRange };
